<template>
  <div id="head-app">
    <header id="site-header">
      <figure class="logo">
        <a href="/">
          <img src="/images/common/logo.webp" alt="Rokuza" />
        </a>
        <figcaption>南房総・館山<br>【鏡ヶ浦温泉rokuza ロクザ】</figcaption>
      </figure>
      
      <div class="menu" @click="toggle = !toggle">
        <div class="menu__icon" :class="{'active': toggle}">
          <i v-for="n of 3" :key="n"></i>
        </div>
        <div class="menu__text" v-if="!toggle">ご案内</div>
        <div class="menu__text" v-else>閉じる</div>
      </div>
  
      <div class="resv">
        <Btn href="/" target="_blank" rel="nofollow" class="resv__btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M602.31-120v-40h133.07q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-350.76H200V-380h-40v-315.38q0-27.62 18.5-46.12Q197-760 224.62-760h70.76v-89.23h43.08V-760h286.16v-89.23h40V-760h70.76q27.62 0 46.12 18.5Q800-723 800-695.38v510.76q0 27.62-18.5 46.12Q763-120 735.38-120H602.31ZM320-28.46 292.46-56l122.23-124H60v-40h354.69L292.46-344 320-371.54 491.54-200 320-28.46ZM200-575.39h560v-119.99q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v119.99Zm0 0V-720-575.39Z"/></svg>ご宿泊予約</Btn>
        <div class="resv__text">
          <dl>
            <dt>TEL.0470-20-5693</dt>
            <dd>受付時間 10:00～21:00</dd>
          </dl>
        </div>
      </div>
  
  
    </header>
    <Transition name="menu">
      <Navigation v-if="toggle" />
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
header{
  width: 100%;
  position: fixed;
  padding: 0 module.side();
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
  > *{
    align-self: center;
  }
  .logo{
    position: fixed;
    top: 1rem;
    left: module.side();
    color: module.tone(module.$normal, 6);
    font-size: .88rem;
    display: grid;
    grid-template-columns: 5.2rem 1fr;
    justify-self: flex-start;
    gap: 1.6rem;
    transition: color 400ms module.$ease;
    >*{
      align-self: center;
    }
    img{
      width: 100%;
    }
  }
  $menuSize: 7.2rem;
  .menu{
    position: fixed;
    top: 0;
    right: 0;
    width: $menuSize;
    height: $menuSize;
    overflow: hidden;
    background: module.$main;
    @include module.flex();
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.6rem 0 1.2rem;
    cursor: pointer;
    user-select: none;
    &:hover{
      &:before{
        width: 100%;
        right: auto;
        left: 0;
      }
    }
    &:before{
      content: '';
      width: 0;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      background: module.$black;
      z-index: 1;
      transition: width 200ms module.$ease;
    }
    &__icon{
      align-items: center;
      width: 40%;
      height: 40%;
      position: relative;
      z-index: 2;
      &.active{
        i{
          &:nth-child(1),
          &:nth-child(2){
            transform: translate(-50%, -50%) scale(.8) rotate(45deg);
            top: 50%;
          }
          &:nth-child(3){
            width: 0;
          }
          &:nth-child(2){
            transform: translate(-50%, -50%) scale(.8) rotate(-45deg);
          }
        }
      }
      i{
        background: module.$white;
        width: 100%;
        height: 1px;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        transition: all 200ms module.$ease;
        &:nth-child(1){
          top: calc(50% - 8px);
        }
        &:nth-child(2){
          top: calc(50% + 8px);
        }
      }
    }
    &__text{
      font-size: .88rem;
      letter-spacing: .16rem;
      width: 100%;
      color: module.$white;
      padding: .2rem 0 0;
      position: relative;
      z-index: 2;
    }
  }

  .resv{
    width: calc(#{$menuSize} * 1.5);
    height: $menuSize;
    position: fixed;
    top: 0;
    right: $menuSize;
    background: module.tone(module.$main, 2);
    border-radius: 0 0 0 1rem;
    overflow: hidden;
    color: module.$white;
    &__btn{
      width: 100%;
      border-radius: 0;
      height: 50%;
      display: block;
      svg{
        width: 1.4rem;
        fill: module.$white;
      }
    }
    &__text{
      font-size: .8rem;
      line-height: 1.5;
      text-align: center;
      height: 50%;
      border-top: rgba(#FFF,.1) 1px solid;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      dd{
        width: 100%;
        font-size: .72rem;
        display: block;
      }
    }
  }
}
.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.5s ease;
}

.menu-enter-from,
.menu-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
header{
  .resv__btn{
    span{
      height: 100%;
      padding: 0;
      border-radius: 0;
      gap: .4rem;
      &:after{
        border-radius: 0;
        background: module.tone(module.$main, 4);
      }
    }
    &:before{
      background: module.tone(module.$main, 2);
      border-radius: 0;
    }
  }
}
</style>

<script>
import { ref } from 'vue';
import Btn from './Btn.vue'
import Navigation from './Navigation.vue'
export default {
  components: {
    Btn: Btn,
    Navigation: Navigation
  },
  setup(){
    const toggle = new ref(false)
    return {
      toggle
    }
  }
}
</script>
